import { Column, OneToMany } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { MSfpSmartFilterGroupRbacRoleEntity } from './m-sfp-smart-filter-group-rbac-role.entity';
import { MSfpSmartFilterEntity } from './m-sfp-smart-filter.entity';

@Entity('m_sfp_smart_filter_group', {}, { label: 'Smart Filter Group' })
export class MSfpSmartFilterGroupEntity extends BaseEntity {
	@Column('varchar', { name: 'label', length: 64 })
	public label!: string;

	@Column('varchar', { name: 'key', length: 64 })
	public key!: string;

	@Column('varchar', { name: 'icon', nullable: true, length: 64 })
	public icon!: string | null;

	@OneToMany(
		() => MSfpSmartFilterEntity,
		(mSfpSmartFilter) => mSfpSmartFilter.fkMSfpSmartFilterGroup,
		{},
	)
	public mSfpSmartFilters!: Array<MSfpSmartFilterEntity>;

	@OneToMany(
		() => MSfpSmartFilterGroupRbacRoleEntity,
		(mSfpSmartFilterGroupRbacRole) =>
			mSfpSmartFilterGroupRbacRole.fkMSfpSmartFilterGroup,
		{},
	)
	public mSfpSmartFilterGroupRbacRoles!: Array<MSfpSmartFilterGroupRbacRoleEntity>;
}
